module.exports = __webpack_public_path__ + "h5/img/live-logo.8fedc240.gif";